import React from 'react';
import ArrAccordion from '../../../components/common/arr-accordion/ArrAccordion';
import {Box} from '@mui/material';

const AccordionExample: React.FC = () => {
  const sections = [
    {
      id: 'section1',
      title: 'Date Range',
      showInfoIcon: true,
      tooltipText: 'more info',
      content:
        'Lorem ipsum dolor, sit amet consectetur adipisicing elit.Lorem ipsum dolor, sit amet consectetur adipisicing elit.',
    },
    {
      id: 'section2',
      title: 'Document Types',
      showInfoIcon: true,
      tooltipText: 'more info',
      content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit.',
    },
    {
      id: 'section3',
      title: 'Tag Action type',
      showInfoIcon: true,
      tooltipText: 'more info',
      content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
      //isDisabled: true,
    },
  ];

  const handleToggle = (sectionId: string) => {
    console.log('toggled section:', sectionId);
  };

  return (
    <Box className="accordion-demo">
      <ArrAccordion
        sections={sections}
        expandedSection="section1"
        onToggle={handleToggle}
        allowMultiple={false}
        dataTestId="accordion-demo"
      />
    </Box>
  );
};

export default AccordionExample;
